import {
    REQUEST_CONTRACTS,
    RECEIVE_CONTRACTS,
    FAILED_CONTRACTS,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_CONTRACTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_CONTRACTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case FAILED_CONTRACTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                errors: action.error,
                message: action.error.server || '',
            }
        default:
            return state
    }
}
